<template>
  <div class="itemtype-manage">
    <el-card class="page-card">
      <el-row type="flex" align="middle" style="margin-bottom: 10px;">
        <el-col :span="6">
          <el-input v-model="keyword" placeholder="按名称搜索" clearable @input="onSearchInput" />
        </el-col>
        <el-col :span="6" class="align-right">
          <el-button type="primary" @click="loadTypes">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
          <el-button type="success" @click="openCreate">新增</el-button>
        </el-col>
      </el-row>

      <el-table :data="types" v-loading="isLoading" style="width:100%">
        <el-table-column prop="name" label="分类名称"></el-table-column>
        <el-table-column prop="count" label="物品数量"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/修改弹窗 -->
    <el-dialog :title="dialogMode === 'create' ? '新增分类' : '修改分类'" :visible.sync="showEditDialog" width="420px">
      <el-form :model="editForm" ref="typeFormRef" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取消</el-button>
        <el-button type="success" :loading="isSaving" @click="submitType">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getItemTypeList, addItemType, updateItemType, deleteItemType } from '@/api/itemType'

export default {
  name: 'ItemTypeManage',
  data() {
    return {
      keyword: '',
      types: [],
      isLoading: false,
      // 编辑
      showEditDialog: false,
      dialogMode: 'create',
      isSaving: false,
      editForm: { id: null, name: '' }
    }
  },
  created() {
    this.loadTypes()
  },
  methods: {
    onSearchInput() {
      // 可做防抖，当前简单按回车或点击查询
    },
    async loadTypes() {
      this.isLoading = true
      try {
        const res = await getItemTypeList()
        if (res && res.data && res.data.code === 200) {
          let data = res.data.data || []
          if (this.keyword) {
            const kw = this.keyword.trim().toLowerCase()
            data = data.filter(d => (d.name || '').toLowerCase().includes(kw))
          }
          this.types = data
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取分类列表失败')
        }
      } catch (error) {
        // 检查是否是因为认证失败导致的错误（401/403）
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          // 认证相关的错误已经在 axios 拦截器中处理并跳转到登录页，无需额外提示
          console.log('Authentication failed, redirecting to login page')
          this.$message.error('长时间未操作，请重新登录')
        } else {
          this.$message.error('获取分类列表异常')
        }
      } finally {
        this.isLoading = false
      }
    },

    resetFilters() {
      this.keyword = ''
      this.loadTypes()
    },

    openCreate() {
      this.dialogMode = 'create'
      this.editForm = { id: null, name: '', icon: '' }
      this.showEditDialog = true
    },

    openEdit(row) {
      this.dialogMode = 'edit'
      this.editForm = { id: row.id, name: row.name, icon: row.icon }
      this.showEditDialog = true
    },

    async submitType() {
      if (!this.editForm.name || !this.editForm.name.trim()) {
        this.$message.warning('请输入分类名称')
        return
      }
      const payload = { id: this.editForm.id, name: this.editForm.name.trim() }
      try {
        this.isSaving = true
        let res
        if (this.dialogMode === 'create') {
          res = await addItemType(payload)
        } else {
          res = await updateItemType(payload)
        }
        if (res && res.data && res.data.code === 200) {
          this.$message.success(this.dialogMode === 'create' ? '新增成功' : '修改成功')
          this.showEditDialog = false
          this.loadTypes()
        } else {
          this.$message.error((res && res.data && res.data.msg) || '保存失败')
        }
      } catch (e) {
        const msg = e?.response?.data?.msg || e?.message || '保存异常'
        this.$message.error(msg)
      } finally {
        this.isSaving = false
      }
    },

    async handleDelete(row) {
      if (!row || !row.id) return
      try {
        await this.$confirm(`确定删除分类 "${row.name}" 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          modal: false
        })
        const res = await deleteItemType(row.id)
        if (res && res.data && res.data.code === 200) {
          this.$message.success('删除成功')
          this.loadTypes()
        } else {
          this.$message.error((res && res.data && res.data.msg) || '删除失败')
        }
      } catch (e) {
        if (e === 'cancel') return
        const msg = e?.response?.data?.msg || e?.message || '删除异常'
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.itemtype-manage {
  .el-card { 
    margin-bottom: 12px;
    
    &.page-card {
      margin-top: -10px;
    }
  }
  .align-right { text-align: right }
}

/* 表格表头样式 */
:deep(.el-table__header-wrapper th),
:deep(.el-table__fixed-header-wrapper th) {
  background-color: #f5f7fa !important;
}
</style>
